<template>
    <div class="kanban-container" ref="kanban">
        <div class="production-kanban-header">【{{ companyName }}】模具进度实时看板</div>

        <div style="overflow: auto;height: 39%;">
            <table class="kanban-table" :style="purchaseTableStyle">
                <tr>
                    <td rowspan="3" style="width: 20px;max-width: 20px;">序号</td>
                    <td rowspan="3" style="width: 40px;max-width: 40px;">模具编号</td>
                    <td rowspan="3" style="width: 110px;max-width: 110px;">产品名称</td>

                    <td :colspan="productDesignBomSize" :style="productDesignStyle">产品设计</td>
                    <td :colspan="moldDesignBomSize" :style="moldDesignStyle">模具设计</td>

                    <td :colspan="moldCoreBomSize" :style="moldCoreStyle">模芯</td>
                    <td :colspan="moldBaseBomSize" :style="moldBaseStyle">模架</td>
                </tr>

                <tr>
                    <td v-for="(item, index) in productDesignList" :key="index" colspan="2">{{ item }}</td>
                    <td v-for="(item, index) in moldDesignList" :key="index" colspan="2">{{ item }}</td>

                    <td v-for="(item, index) in moldCoreList" :key="index" colspan="2">{{ item }}</td>
                    <td v-for="(item, index) in moldBaseList" :key="index" colspan="2">{{ item }}</td>
                </tr>

                <tr>

                    <td v-for="item in productDesignBomSize" :key="item" style="width: 75px;">
                        {{ item % 2 == 0 ? "完成时间" : "开始时间" }}
                    </td>
                    <td v-for="item in moldDesignBomSize" :key="item" style="width: 75px;">
                        {{ item % 2 == 0 ? "完成时间" : "开始时间" }}
                    </td>

                    <td v-for="item in moldCoreBomSize" :key="item" style="width: 75px;">
                        {{ item % 2 == 0 ? "完成时间" : "开始时间" }}
                    </td>
                    <td v-for="item in moldBaseBomSize" :key="item" style="width: 75px;">
                        {{ item % 2 == 0 ? "完成时间" : "开始时间" }}
                    </td>
                </tr>

                <tr :class="item.idx % 2 == 1 ? 'kanban-tr' : 'kanban-tr-odd'" v-for="(item, idx) in purchaseKanbanList"
                    :key="idx">
                    <td>{{ item.idx + 1 }}</td>
                    <td>{{ item.moldCode }}</td>
                    <td>{{ item.productName }}</td>

                    <td v-for="(bomTime, index) in item.productDesignBomStartAndEndTimeList" :key="index">
                        {{ bomTime }}
                    </td>
                    <td v-for="(bomTime, index) in item.moldDesignBomStartAndEndTimeList" :key="index">
                        {{ bomTime }}
                    </td>

                    <td v-for="(bomTime, index) in item.moldCoreBomStartAndEndTimeList" :key="index">
                        {{ bomTime }}
                    </td>
                    <td v-for="(bomTime, index) in item.moldBaseBomStartAndEndTimeList" :key="index">
                        {{ bomTime }}
                    </td>
                </tr>
            </table>

            <div style="height: 10px;"></div>
        </div>

        <div style="height: 10px;"></div>

        <!-- 分页 -->
        <div>
            <el-pagination background :page-size="pageNum" :page-count="pageCount"
                layout="total, sizes,prev, pager, next" :total="total" @current-change="pageClick"
                :page-sizes="[10, 15, 20, 25]" @size-change="handleSizeChange">
            </el-pagination>
        </div>

        <div style="height: 10px;"></div>

        <div style="overflow: auto;height: 39%;">
            <table class="kanban-table" :style="processTableStyle">
                <tr>
                    <td rowspan="3" style="width: 20px;max-width: 20px;">序号</td>
                    <td rowspan="3" style="width: 40px;max-width: 40px;">模具编号</td>
                    <td rowspan="3" style="width: 110px;max-width: 110px;">产品名称</td>

                    <!-- <td :colspan="productDesignBomSize">产品设计</td>
                    <td :colspan="moldDesignBomSize">模具设计</td> -->

                    <td :colspan="moldCoreProcessBomSize">模芯</td>
                    <td :colspan="moldBaseProcessBomSize">模架</td>
                </tr>

                <tr>

                    <!-- <td v-for="(item, index) in productDesignList" :key="index" colspan="2">{{ item }}</td>
                    <td v-for="(item, index) in moldDesignList" :key="index" colspan="2">{{ item }}</td> -->

                    <td v-for="(item, index) in moldCoreProcessList" :key="index" colspan="2">{{ item }}</td>
                    <td v-for="(item, index) in moldBaseProcessList" :key="index" colspan="2">{{ item }}</td>
                </tr>

                <tr>

                    <!-- <td v-for="item in productDesignBomSize" :key="item" style="width: 86px;">{{ item % 2 == 0 ? "完成时间" : "开始时间" }}
                    </td>
                    <td v-for="item in moldDesignBomSize" :key="item" style="width: 86px;">{{ item % 2 == 0 ? "完成时间" : "开始时间" }}
                    </td> -->

                    <td v-for="item in moldCoreProcessBomSize" :key="item"
                        :class="item % 2 == 0 ? 'kanban-down-td-oran' : ''">
                        {{ item % 2 == 0 ? "完成时间" : "开始时间" }}</td>

                    <td v-for="item in moldBaseProcessBomSize" :key="item"
                        :class="item % 2 == 0 ? 'kanban-down-td-oran' : ''">
                        {{ item % 2 == 0 ? "完成时间" : "开始时间" }}</td>
                </tr>

                <tr :class="item.idx % 2 == 1 ? 'kanban-tr' : 'kanban-tr-odd'" v-for="(item, idx) in processKanbanList"
                    :key="idx">

                    <td>{{ item.idx + 1 }}</td>
                    <td>{{ item.moldCode }}</td>
                    <td>{{ item.productName }}</td>

                    <!-- <td v-for="(bomTime, index) in item.productDesignBomStartAndEndTimeList" :key="index">{{ bomTime }}</td>
                    <td v-for="(bomTime, index) in item.moldDesignBomStartAndEndTimeList" :key="index">{{ bomTime }}</td> -->

                    <td v-for="(bomTime, index) in item.moldCoreBomStartAndEndTimeList" :key="index">{{ bomTime }}</td>
                    <td v-for="(bomTime, index) in item.moldBaseBomStartAndEndTimeList" :key="index">{{ bomTime }}</td>
                </tr>
            </table>

            <div style="height: 10px;"></div>
        </div>

        <div style="position: absolute;right: 30px;bottom: 5px;">
            <i class="el-icon-full-screen" @click="fullScreen" style="color:orange"></i>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            token: this.getToken(),
            companyId: this.getCompanyId(),

            companyName: '中国模具',
            orderList: [{ moldCode: '0001', productName: '透镜01' }],
            purchaseKanbanList: [],
            purchaseTableStyle: { width: '2000px' },
            processTableStyle: { width: '556px' },

            index: 0,
            statusSearch: 0,
            productDesignList: [{ name: '3D' }, { name: '2D' }],
            productDesignBomSize: 0,
            productDesignStyle: { width: '172px' },

            moldDesignList: [],
            moldDesignBomSize: 0,
            moldDesignStyle: { width: '172px' },

            moldCoreList: [],
            moldCoreBomSize: 0,
            moldCoreStyle: { width: '172px' },

            moldBaseList: [],
            moldBaseBomSize: 0,
            moldBaseStyle: { width: '172px' },

            processKanbanList: [],

            moldCoreProcessList: [],
            moldCoreProcessBomSize: 0,
            moldCoreProcessStyle: { width: '172px' },

            moldBaseProcessList: [],
            moldBaseProcessBomSize: 0,
            moldBaseProcessStyle: { width: '172px' },
            pageIndex: 0,
            pageNum: 10,
            total: 0,
            pageCount: 0
        }
    },
    methods: {
        getAll() {

            const formData = new FormData()

            formData.append('companyId', this.companyId)

            this.$axios({
                method: "post",
                url: "/shiro/kanban/getAll",
                data: formData,
                headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                if (data.status === 400) {
                    this.$router.push({ path: "/Login" })
                }

                if (data.status === 202) {
                    this.$notify({
                        title: '重要提示',
                        message: data.msg,
                        duration: 0
                    })
                    return
                }

                this.purchaseKanbanList = data.data

                if (this.purchaseKanbanList[0].productDesignMaxBomCount > 0) {
                    this.productDesignBomSize = this.purchaseKanbanList[0].productDesignMaxBomCount * 2
                    this.productDesignList = this.purchaseKanbanList[0].productDesignBomNameList
                    this.productDesignStyle.width = this.productDesignBomSize * 75 + 'px'
                }

                if (this.purchaseKanbanList[0].moldDesignMaxBomCount > 0) {
                    this.moldDesignBomSize = this.purchaseKanbanList[0].moldDesignMaxBomCount * 2
                    this.moldDesignList = this.purchaseKanbanList[0].moldDesignBomNameList
                    this.moldDesignStyle.width = this.moldDesignBomSize * 75 + 'px'
                }

                if (this.purchaseKanbanList[0].moldCoreMaxBomCount) {
                    this.moldCoreBomSize = this.purchaseKanbanList[0].moldCoreMaxBomCount * 2
                    this.moldCoreList = this.purchaseKanbanList[0].moldCoreBomNameList
                    this.moldCoreStyle.width = this.moldCoreBomSize * 75 + 'px'
                }

                if (this.purchaseKanbanList[0].moldBaseMaxBomCount > 0) {
                    this.moldBaseBomSize = this.purchaseKanbanList[0].moldBaseMaxBomCount * 2
                    this.moldBaseList = this.purchaseKanbanList[0].moldBaseBomNameList
                    this.moldBaseStyle.width = this.moldBaseBomSize * 75 + 'px'
                }

                this.purchaseTableStyle.width = (this.productDesignBomSize + this.moldDesignBomSize + this.moldCoreBomSize + this.moldBaseBomSize) * 75 + 170 + 'px'
                // console.log(this.purchaseTableStyle.width)

                let purchaseKanbanPageList = []
                this.total = this.purchaseKanbanList.length
                // console.log('total')
                // console.log(this.total)

                for (let i = this.pageIndex; i < this.total && i < (this.pageIndex + this.pageNum); i++) {

                    this.purchaseKanbanList[i].idx = i
                    let productName = this.purchaseKanbanList[i].productName

                    if (productName.length > 8) {
                        this.purchaseKanbanList[i].productName = productName.substring(0, 8) + '...'
                    }

                    let timeList = []
                    for (var k = 0; k < 4; k++) {

                        if (k == 0) {
                            timeList = this.purchaseKanbanList[i].productDesignBomStartAndEndTimeList
                        } else if (k == 1) {
                            timeList = this.purchaseKanbanList[i].moldDesignBomStartAndEndTimeList
                        } else if (k == 2) {
                            timeList = this.purchaseKanbanList[i].moldCoreBomStartAndEndTimeList
                        } else {
                            timeList = this.purchaseKanbanList[i].moldBaseBomStartAndEndTimeList
                        }

                        for (let j in timeList) {
                            if (timeList[j] != '-' && timeList[j] != '***') {

                                timeList[j] = this.$moment(timeList[j]).format("YY-MM-DD HH")
                            }

                            // console.log('timeList')
                            // console.log(timeList[j])
                        }
                    }

                    purchaseKanbanPageList.push(this.purchaseKanbanList[i])

                }
                this.purchaseKanbanList = purchaseKanbanPageList

            })
        },
        getProcess() {

            const formData = new FormData()

            formData.append('companyId', this.companyId)

            this.$axios({
                method: "post",
                url: "/shiro/kanban/getProcess",
                data: formData,
                headers: {
                    token: this.token
                }
            }).then(result => {
                const data = result.data

                console.log('getProcess')
                // console.log(data)

                if (data.status === 400) {
                    this.$router.push({ path: "/Login" })
                }

                if (data.data.length == 0) {
                    return
                }

                this.processKanbanList = data.data
                // console.log('processKanbanList')
                // console.log(this.processKanbanList)

                if (this.processKanbanList[0].moldCoreMaxBomCount > 0) {

                    this.moldCoreProcessBomSize = this.processKanbanList[0].moldCoreMaxBomCount * 2

                    this.moldCoreProcessList = this.processKanbanList[0].moldCoreBomNameList
                    this.moldCoreProcessStyle = this.moldCoreProcessBomSize * 75 + 'px'
                }

                if (this.processKanbanList[0].moldBaseMaxBomCount > 0) {
                    this.moldBaseProcessBomSize = this.processKanbanList[0].moldBaseMaxBomCount * 2
                    this.moldBaseProcessList = this.processKanbanList[0].moldBaseBomNameList
                    this.moldBaseProcessStyle = this.moldBaseProcessBomSize * 75 + 'px'
                }

                this.processTableStyle.width = (this.moldCoreProcessBomSize + this.moldBaseProcessBomSize) * 75 + 170 + 'px'

                let processKanbanPageList = []
                this.total = this.processKanbanList.length

                for (let i = this.pageIndex; i < this.total && i < (this.pageIndex + this.pageNum); i++) {

                    this.processKanbanList[i].idx = i
                    let productName = this.processKanbanList[i].productName
                    if (productName.length > 8) {
                        this.processKanbanList[i].productName = productName.substring(0, 8) + '...'
                    }

                    let timeList = []
                    for (var k = 0; k < 2; k++) {
                        if (k == 0) {
                            timeList = this.processKanbanList[i].moldCoreBomStartAndEndTimeList
                        } else if (k == 1) {
                            timeList = this.processKanbanList[i].moldBaseBomStartAndEndTimeList
                        }

                        for (let j in timeList) {
                            if (timeList[j] != '-' && timeList[j] != '***') {
                                timeList[j] = this.$moment(timeList[j]).format("YY-MM-DD HH")
                            }

                        }
                    }
                    processKanbanPageList.push(this.processKanbanList[i])

                }
                this.processKanbanList = processKanbanPageList
            })
        },
        fullScreen() {
            
            let element = this.$refs.kanban

            if (this.fullscreen) {
                if (document.exitFullscreen) {
                    document.exitFullscreen();
                } else if (document.webkitCancelFullScreen) {
                    document.webkitCancelFullScreen();
                } else if (document.mozCancelFullScreen) {
                    document.mozCancelFullScreen();
                } else if (document.msExitFullscreen) {
                    document.msExitFullscreen();
                }
            } else {
                if (element.requestFullscreen) {
                    element.requestFullscreen();
                } else if (element.webkitRequestFullScreen) {
                    element.webkitRequestFullScreen();
                } else if (element.mozRequestFullScreen) {
                    element.mozRequestFullScreen();
                } else if (element.msRequestFullscreen) {
                    element.msRequestFullscreen();
                }
            }
            this.fullscreen = !this.fullscreen;
        },
        pageClick(currentPage) {

            this.purchaseKanbanList = []
            this.processKanbanList = []
            
            this.pageIndex = (currentPage - 1) * this.pageNum

            this.getAll()
            this.getProcess()
        },
        handleSizeChange(val) {
            
            this.pageNum = val

            this.getAll()
            this.getProcess()
        },
    },
    created() {
        // console.log('created')
    },
    mounted() {

        this.getAll()

        this.getProcess()

        this.$axios({
            method: "post",
            url: "/shiro/company/get",
            data: {
                id: this.companyId
            }, headers: {
                token: this.token
            }
        }).then(result => {
            this.companyName = result.data.data.companyName
        })

    },
    updated() {
        // console.log('updated')
    }
}
</script>

<style>
.kanban-container {
    width: 100%;
    height: 800px;
    background-color: #06207D;
    box-shadow: 0px 10px 10px 0px rgba(0, 0, 0, 0.5);
    border-radius: 5px;
    position: relative;
}

.production-kanban-header {
    font-size: 25px;
    font-weight: bolder;
    color: white;
    line-height: 100px;
}

.kanban-table {
    width: 556px;
    table-layout: fixed;
    border: 1px solid white;
    font-size: 15px;
    color: white;
    border-collapse: collapse;
}

.kanban-tr-odd {
    font-size: 13px;
    color: black;
    background-color: white;
}

.kanban-tr {
    font-size: 13px;
    color: black;
    background-color: greenyellow;
}

.kanban-table td {
    border: 1px solid white;
}

.kanban-tr-odd td,
.kanban-tr td {
    border: 1px solid black;
}

.kanban-down-td-oran {
    width: 75px;
    color: orange;
}

div::-webkit-scrollbar {
    background: #6f5499;
    border-radius: 10px;
    width: 10px;
    height: 10px;
}

div::-webkit-scrollbar-thumb {
    background: orange;
    border-radius: 10px;
}

.el-pagination__total {
    color: white;
}

</style>